import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { templateService } from '../services/templateService';

export const getNotesTemplateTypes = createAsyncThunk(
  'template/getNotesTemplateTypes',
  async (_, { rejectWithValue }) => {
    try {
      const response = await templateService.getNotesTemplateTypes();
      return response?.data || response;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

export const getPatientMessagesTemplateTypes = createAsyncThunk(
  'template/getPatientMessagesTemplateTypes',
  async (_, { rejectWithValue }) => {
    try {
      const response = await templateService.getPatientMessagesTemplateTypes();
      return response?.data || response;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

const templateSlice = createSlice({
  name: 'template',
  initialState: {
    notesTemplateTypes: [],
    patientMessagesTemplateTypes: [],
    loading: false,
    error: null,
  },
  reducers: {
    clearError: (state) => {
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getNotesTemplateTypes.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(getNotesTemplateTypes.fulfilled, (state, action) => {
        state.loading = false;
        state.notesTemplateTypes = action.payload;
      })
      .addCase(getNotesTemplateTypes.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      .addCase(getPatientMessagesTemplateTypes.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(getPatientMessagesTemplateTypes.fulfilled, (state, action) => {
        state.loading = false;
        state.patientMessagesTemplateTypes = action.payload;
      })
      .addCase(getPatientMessagesTemplateTypes.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export const { clearError } = templateSlice.actions;

export default templateSlice.reducer;
